import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

const SOP_FILE_URL = 'https://customer-assets.emergentagent.com/job_97725229-7456-4625-a973-72749269d95f/artifacts/700tdwyz_HR%20DEPARTMENT%20SOP.docx';

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h3 className="text-base font-bold text-stone-800 mb-3 pb-2 border-b-2 border-blue-600">{title}</h3>
    <div className="text-sm text-stone-700 leading-relaxed space-y-1.5">{children}</div>
  </div>
);

const Bullets = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);

const Numbered = ({ items }) => (
  <ol className="list-decimal pl-6 space-y-1">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ol>
);

export default function SOPTab() {
  return (
    <div className="space-y-4" data-testid="hr-sop-tab">
      <div className="flex items-center justify-between bg-blue-900 text-white px-4 py-3 rounded-lg">
        <div className="flex items-center gap-3">
          <FileText className="w-5 h-5" />
          <div>
            <h2 className="text-lg font-bold">HR DEPARTMENT — Standard Operating Procedure (SOP)</h2>
            <p className="text-xs text-blue-200">Siddhivinayak Builder and Developers · Department: HR</p>
          </div>
        </div>
        <a href={SOP_FILE_URL} target="_blank" rel="noopener noreferrer" download>
          <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="sop-download-btn">
            <Download className="w-4 h-4 mr-1.5" /> Download .docx
          </Button>
        </a>
      </div>

      <Card>
        <CardContent className="p-6">
          <Section title="Personnel">
            <Bullets items={[
              'Name: 1) Nayna Palherkar  2) Sahil Karale',
              'Emp Code: 00',
              'Department: HR',
              'Mobile No: 7387808927',
            ]} />
          </Section>

          <Section title="Office Entry at 09:45 AM">
            <Bullets items={[
              'Sign on attendance register',
              'Bag submits',
              'Desk cleaning',
              'PC start',
              'Today work file writing',
            ]} />
          </Section>

          <Section title="Morning Schedule">
            <Numbered items={[
              'Project-wise planning and thinking of DBK Group: Sai Plaza (Rajgurunagar), Office Dream Riviera, Bramha Heights, Godavari Heights, Kaveri Heights, Krushna Heights, Dreams Kokan City, Dreams Nagpur City',
              'Attendance status',
              'Take follow-up from the team about their work',
              'Leave planning (managing shrinkage for the day)',
              'Staff meeting (morning startup meeting)',
              'Need to check the requirement of all departments',
              'Report to the senior of daily staff work schedule',
              'Work planning & follow-up',
              'Staff training',
              'Apply penalty to the employees as per rules',
              'Daily all staff evening follow-up with work status',
              'Reporting',
            ]} />
          </Section>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Section title="Weekly Work">
              <Bullets items={[
                'Leave planning', 'Agreements', 'Training',
                'Performance checking of staff', 'File check of staff every Saturday',
                'All department requirements check', 'Office environment check',
                'All site project work follow-up', 'Field staff work auditing',
                'Dress code check of all staff', 'Weekly staff meeting arrangement',
                'Weekly all staff work report to CMD sir', 'Weekly site work report to CMD sir',
              ]} />
            </Section>

            <Section title="Monthly Work">
              <Bullets items={[
                'Leave planning', 'Agreements', 'Training',
                'Performance checking of staff', 'File check of staff',
                'All department requirements check', 'Office environment check',
                'All site project work follow-up', 'Field staff work auditing',
                'Monthly staff meeting arrangement', 'Monthly all staff work report to CMD sir',
                'New staff requirement', 'All staff performance measurement',
                'Salary calculation of all staff', 'Dress code, pen drive, laptop check',
                'Daily today work file making of all staff', 'New recruitment and requirement',
                'Recruitment sources development',
              ]} />
            </Section>
          </div>

          <Section title="HR Formats (42 documents)">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-1">
              {[
                'Application/Requirement form', 'Sources of recruitment', 'Resume acceptance',
                'First interview', 'Second interview', 'Joining letter',
                'Joining form', 'Appointment letter', 'Probation letter',
                'Award & Reward', 'Job confirmation letter', 'Employee agreement',
                'Vendor agreement', 'Id card', 'Visiting card',
                'Dress code', 'Leave application', 'Job promotion letter',
                'Salary advance letter', 'Salary advances form', 'Opalization letter',
                'Salary slip', 'Resignation letter', 'Experience letter',
                'Exit interview letter', 'Report file', 'Senior report',
                'Daily work', 'Weekly work', 'Self-work list',
                'Team work list', 'Staff payment calculation', 'Presently register',
                'Morning meeting', 'Field staff controlling', 'Daily calling',
                'Suggestion dairy', 'Development idea', 'Probation Apposition',
                'Performance measurement', 'Cost of company',
              ].map((f, i) => (
                <div key={i} className="flex items-center gap-2 text-sm py-0.5">
                  <span className="w-5 h-5 rounded-full bg-blue-100 text-blue-700 text-[10px] font-bold flex items-center justify-center">{i+1}</span>
                  {f}
                </div>
              ))}
            </div>
          </Section>
        </CardContent>
      </Card>
    </div>
  );
}
